/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerDeleteResponse
 */
export interface PlannerDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PlannerDeleteResponse
     */
    deleted: boolean;
}

/**
 * Check if a given object implements the PlannerDeleteResponse interface.
 */
export function instanceOfPlannerDeleteResponse(value: object): value is PlannerDeleteResponse {
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    return true;
}

export function PlannerDeleteResponseFromJSON(json: any): PlannerDeleteResponse {
    return PlannerDeleteResponseFromJSONTyped(json, false);
}

export function PlannerDeleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerDeleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'deleted': json['deleted'],
    };
}

export function PlannerDeleteResponseToJSON(json: any): PlannerDeleteResponse {
    return PlannerDeleteResponseToJSONTyped(json, false);
}

export function PlannerDeleteResponseToJSONTyped(value?: PlannerDeleteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deleted': value['deleted'],
    };
}

